export enum FETCH_ERROR {
  UNAUTHORIZED = "unauthorized",
}
